const ChatFilterOptions = {
  STARTED: 'STARTED',
  ENDED: 'ENDED',
  SOFT_DELETED: 'SOFT_DELETED',
  INITIALIZING: 'INITIALIZING'
};
export default ChatFilterOptions;